import {
  getPrefillQueryKeyFromUuid,
  mapLenderCentricSortingValue,
  parseInputFromFormData,
} from '../../common/utils'
import QUERY_PREFILL from '../queries/mortgage-widget-prefill-submission'
import QUERY_SUBMISSION from '../queries/mortgage-widget-submission'
import MUTATION_PRODUCTS from '../mutations/mortgage-widget-fetch-products'

const querySubmission = (client, uuid, productTypes, lenderCentricProducts, bestProduct) =>
  new Promise((resolve, reject) => {
    client
      .query({
        query: QUERY_SUBMISSION,
        variables: {
          uuid,
          productTypes,
          lenderCentricProducts,
          bestProduct,
          sortingField: lenderCentricProducts ? 'apr' : undefined,
        },
        fetchPolicy: 'network-only',
      })
      .then(({ data }) => resolve(data.mortgageWidgetSubmission))
      .catch((err) => reject(err))
  })

const getPurchasePrefillData = ({
  client,
  uuid,
  zipCode,
  productTypes,
  loanType,
  lenderCentricProducts,
  loanTypes,
}) => {
  return new Promise((resolve, reject) => {
    const commonVariables = {
      sortingField: lenderCentricProducts ? 'apr' : undefined,
      lenderCentricProducts,
      productTypes,
      ...(loanTypes && { loanTypes }),
    }
    client
      .query({
        query: uuid ? QUERY_SUBMISSION : QUERY_PREFILL,
        variables: uuid
          ? {
              uuid,
              ...commonVariables,
            }
          : {
              vertical: 'purchaseBrokerLight',
              zipCode,
              loanType,
              ...commonVariables,
            },
      })
      .then(({ data }) => {
        if (!uuid) {
          resolve(data[getPrefillQueryKeyFromUuid(uuid)])
        } else if (data?.[getPrefillQueryKeyFromUuid(uuid)]?.status === 'responseReceived') {
          resolve(data[getPrefillQueryKeyFromUuid(uuid)])
        } else {
          const querySubmissionInterval = setInterval(() => {
            querySubmission(client, uuid, productTypes, lenderCentricProducts)
              .then((pollingData) => {
                const queryStatus = pollingData?.status
                if (
                  queryStatus === 'responseReceived' ||
                  queryStatus === 'noOffers' ||
                  queryStatus === 'error'
                ) {
                  if (!pollingData?.products || pollingData.products?.length === 0) {
                    clearInterval(querySubmissionInterval)
                    reject(new Error('No products found'))
                    return
                  }
                  clearInterval(querySubmissionInterval)
                  resolve(pollingData)
                }
              })
              .catch((error) => {
                reject(error)
              })
          }, 2000)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}
const getRefinancePrefillData = (client, uuid, zipCode, productTypes, loanType, bestProduct) =>
  new Promise((resolve, reject) => {
    client
      .query({
        query: uuid ? QUERY_SUBMISSION : QUERY_PREFILL,
        variables: uuid
          ? { uuid, productTypes, bestProduct }
          : { vertical: 'refinanceBrokerLight', zipCode, productTypes, loanType, bestProduct },
      })
      .then(({ data }) => {
        if (!uuid) {
          resolve(data[getPrefillQueryKeyFromUuid(uuid)])
        } else if (data?.[getPrefillQueryKeyFromUuid(uuid)]?.status === 'responseReceived') {
          resolve(data[getPrefillQueryKeyFromUuid(uuid)])
        } else {
          const querySubmissionInterval = setInterval(() => {
            querySubmission(client, uuid, productTypes, undefined, bestProduct).then(
              (pollingData) => {
                const queryStatus = pollingData?.status
                if (
                  queryStatus === 'responseReceived' ||
                  queryStatus === 'noOffers' ||
                  queryStatus === 'error'
                ) {
                  if (!pollingData?.products || pollingData.products?.length === 0) {
                    clearInterval(querySubmissionInterval)
                    reject(new Error('No products found'))
                    return
                  }
                  clearInterval(querySubmissionInterval)
                  resolve(pollingData)
                }
              },
            )
          }, 2000)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })

const getNewSubmissionProducts = (
  client,
  formData,
  productTypes,
  lenderCentricProducts,
  bestProduct,
  loanTypes,
) => {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: MUTATION_PRODUCTS,
        variables: {
          input: parseInputFromFormData(formData),
          productTypes,
          lenderCentricProducts,
          sortingField: lenderCentricProducts
            ? mapLenderCentricSortingValue(formData?.values?.sorting)
            : undefined,
          ...(loanTypes && { loanTypes }),
          ...(bestProduct && { bestProduct }),
        },
      })
      .then(({ data }) => {
        const { mortgageWidgetFetchProducts } = data
        const { status, products, uuid, vertical: loanType, ...rest } = mortgageWidgetFetchProducts

        if (status === 'responseReceived') {
          resolve({ uuid, products, loanType, ...rest })
          return
        }

        const querySubmissionInterval = setInterval(() => {
          querySubmission(client, uuid, productTypes, lenderCentricProducts, bestProduct).then(
            ({ status: queryStatus, products: queryProducts }) => {
              if (
                queryStatus === 'responseReceived' ||
                queryStatus === 'noOffers' ||
                queryStatus === 'error'
              ) {
                clearInterval(querySubmissionInterval)
                resolve({
                  uuid,
                  products: queryProducts,
                  loanType,
                  ...rest,
                })
              }
            },
          )
        }, 2000)
      })
      .catch((err) => reject(err))
  })
}

export {
  querySubmission,
  getPurchasePrefillData,
  getRefinancePrefillData,
  getNewSubmissionProducts,
}
